import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { ExtensionState } from '../state/extension.state';
import { initialExtensionState } from '../state/extension.state';
import { UpdateExtensionInstallState } from '../action/extension.action';

const extensionReducer = createReducer(
  initialExtensionState,

  on(UpdateExtensionInstallState, (state: ExtensionState, props) => ({ ...state, isInstalled: props.isExtensionInstalled })),
);

export function ExtensionReducer(state: ExtensionState | undefined, action: Action) {
  return extensionReducer(state, action);
}
